import { useAppSelector } from 'app/redux/store';
import { Banner, BannerText } from './ProjectBanner.styles';

export const ProjectBanner = () => {
  const { facility } = useAppSelector(state => state.profile);
  if (!facility.isVirtual) return null;
  return (
    <Banner>
      <BannerText>{facility.name}</BannerText>
    </Banner>
  );
};
